import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="global-footer">
      <div className="footer-inner">
        <p className="footer-copyright">
          © 2026 Smart Transform 5.0 Forschungsprojekt. Alle Rechte vorbehalten.
        </p>
        <p className="footer-links">
          <Link to="/impressum">Impressum</Link>
          <span> | </span>
          <Link to="/datenschutz">Datenschutz</Link>
          <span> | </span>
          <Link to="/kontakt">Kontakt</Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
